import {
  createToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  Toaster as ChakraToaster,
} from '@chakra-ui/react';

import { ToastIndicator } from './ToastIndicator';

export const toastStore = createToaster({
  placement: 'top',
  pauseOnPageIdle: true,
});

export const Toaster = () => (
  <Portal>
    <ChakraToaster insetInline={{ mdDown: '4' }} toaster={toastStore}>
      {(toast) => (
        <Toast.Root>
          {toast.type === 'loading' ? (
            <Spinner color="blue.solid" size="sm" />
          ) : (
            toast.type && <ToastIndicator type={toast.type} />
          )}
          <Stack flex="1" gap="0" maxWidth="100%">
            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
            {toast.description && (
              <Toast.Description>{toast.description}</Toast.Description>
            )}
          </Stack>
          {toast.action && (
            <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
          )}
          {toast.closable && <Toast.CloseTrigger />}
        </Toast.Root>
      )}
    </ChakraToaster>
  </Portal>
);
